import React from 'react';
import { connect, useSelector } from 'react-redux';
import { CommonHeader } from '../../components/commons';
import ListCard from '../../components/Reports/ListCard/ListCard';
import { RootState } from '../../redux/rootReducers';
import { useParams } from 'react-router-dom';

type AppProps = {
  history?: any;
  companyName:string;
}

const Reports = ({
  history,
  companyName
}: AppProps) => {
  const {id}:any=useParams()

  const client_code = history?.location?.state?.client_code ? history?.location?.state?.client_code : id;
  const company_name = history?.location?.state?.company_name ? history?.location?.state?.company_name : companyName;

  const modules = useSelector((state: RootState) => state.auth.modules);

  let reportsMenu: any = modules && modules?.length > 0 && modules?.filter(menu => menu?.menu_name === 'Reports');

  const renderReports = () => {
      window.scrollTo(0 ,0)
    let finalReports = reportsMenu && reportsMenu[0]?.sub_menu && reportsMenu[0]?.sub_menu?.length > 0 && reportsMenu[0]?.sub_menu?.map((reports: any) => {
      return (
        <div className="col-md-4">
          <ListCard
            key={reports?.menu_id}
            listTitle={reports?.menu_name}
            list={reports?.sub_menu}
            client_code={client_code}
            company_name={company_name}
          />
        </div>
      )
    });

    return finalReports
  }

  return (
    <>
      <CommonHeader
        title='Reports'
        company_name={company_name}
        client_code={client_code}
      />
      <div className="pt-4">
        <div className="row">
          {renderReports()}
        </div>
      </div>
    </>
  )
};

const mapStateToProps = (state: RootState) => ({
  companyName: state.auth.companyName
});



export default connect(
  mapStateToProps
)(Reports);
